import * as R from 'ramda';

export default function EditAuthorityAndManagementDialogController(
  $rootScope,
  $scope,
  $q,

  confirmDialog,
  alerts,
  ssDialogService,
  loaderService,
  bcpUtilityService,
  orgDataService,
  bcpDataService,
  editInternalContactDialog,
) {
  const vm = this;
  vm.showFilters = true;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleFormSubmit = _handleFormSubmit;
  vm.handleAddInternalContactClick = _handleAddInternalContactClick;
  vm.handleEditInternalContactClick = _handleEditInternalContactClick;
  vm.handleShowConfirmDeleteInternalContactDialogClick = _handleShowConfirmDeleteInternalContactDialogClick;
  vm.refreshInternalContacts = _refreshInternalContacts;

  vm.newInternalContacts = angular.copy(vm.internalContacts);

  _activate();

  /** ******************************************
   * Event Handlers
   */

  function _handleCloseDialogClick() {
    _closeDialog();
  }

  function _handleFormSubmit() {
    loaderService.showViewLoader = true;
    const contactsToSave = bcpUtilityService.transformInternalContactsForSave(vm.newInternalContacts);
    bcpDataService.saveTeamContacts(vm.assessmentId, contactsToSave).then(() => {
      loaderService.showViewLoader = false;
      alerts.success('The Management Team assignments have been successfully saved.');
      //$rootScope.$broadcast('refreshInternalContacts');
      //$rootScope.$broadcast('refreshStatuses');
      $rootScope.$broadcast('refreshBCPAssessments');
      if (vm.saveType === 'saveAndClose') {
        _closeDialog();
      }
    });
    loaderService.showGlobalLoader = false;
  }

  function _handleAddInternalContactClick($event) {
    ssDialogService.dialogs.bcp.editInternalContactDialog = ssDialogService.alert(
      editInternalContactDialog.getOptions($event, {
        user: {
          userId: 0,
          authenticationSource: 'None',
          customerId: vm.customerId,
        },
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editInternalContactDialog);
  }

  function _handleEditInternalContactClick($event, user) {
    ssDialogService.dialogs.bcp.editInternalContactDialog = ssDialogService.alert(
      editInternalContactDialog.getOptions($event, {
        user,
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editInternalContactDialog);
  }

  function _handleShowConfirmDeleteInternalContactDialogClick($event, user) {
    ssDialogService.dialogs.bcp.confirmDeleteInternalContactDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete User?',
        message: `Are you sure you want to delete the user "${user.fullName}"?`,
        handleYesClick: () => {
          _handleYesDeleteInternalContactDialogClick(user.userId);
        },
        handleNoClick: () => {
          _handleCloseConfirmDeleteInternalContactDialogClick();
        },
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteInternalContactDialog);
  }

  function _handleYesDeleteInternalContactDialogClick(userId) {
    loaderService.showViewLoader = true;
    const dfdDeleteUser = orgDataService.deleteUser(userId);
    dfdDeleteUser.then(deleteUserResponse => {
      if (deleteUserResponse.status === 200) {
        alerts.success('Internal Contact has been deleted successfully.');
        _refreshInternalContacts();
      } else {
        alerts.error('Error occurred while deleting Internal Contact.');
      }
      loaderService.showViewLoader = false;
      _handleCloseConfirmDeleteInternalContactDialogClick();
    });
  }

  function _handleCloseConfirmDeleteInternalContactDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteInternalContactDialog);
  }

  /** ******************************************
   * Private Functions
   */

  function _activate() {
    console.log(vm.permissions);
    _initEventListeners();
    _initFilters();
  }

  function _initEventListeners() {
    $scope.$on('internalContactsRefreshed', (scope, internalContacts) => {
      vm.internalContacts = internalContacts;
    });

    $scope.$on('refreshInternalContacts', () => {
      _UpdateDialogRefreshInternalContacts();
    });
  }

  function _initFilters() {
    _resetFilters();
  }

  function _resetFilters() {
    vm.contactFilters = {
      includeInitialResponseTeam: true,
      includeCrisisManagementTeam: true,
      includeDepartmentRecoveryTeam: true,
      includeNoTeam: true,
    };
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editAuthorityAndManagementDialog);
  }

  function _refreshInternalContacts() {
    $rootScope.$broadcast('refreshInternalContacts');
  }

  function _UpdateDialogRefreshInternalContacts() {
    loaderService.showViewLoader = true;
    const dfdContactRefresh = $q.defer();
    bcpDataService.getAuthorityAndManagement(vm.assessmentId).then(response => {
      let _newInternalContacts = bcpUtilityService.transformInternalUsersData(response.data);

      if (vm.newInternalContacts !== undefined) {
        if (_newInternalContacts !== undefined) {
          R.forEach(vmnic => {
            R.forEach(rnic => {
              if (rnic.userId === vmnic.userId) {
                rnic.onCrisisManagementTeam = vmnic.onCrisisManagementTeam;
                rnic.onDepartmentalRecoveryTeam = vmnic.onDepartmentalRecoveryTeam;
                rnic.onInitialResponseTeam = vmnic.onInitialResponseTeam;
              }
            }, _newInternalContacts);
          }, vm.newInternalContacts);
        }
      }

      loaderService.showViewLoader = false;
      vm.newInternalContacts = _newInternalContacts;
      dfdContactRefresh.resolve();
    });
    return dfdContactRefresh.promise;
  }
}

EditAuthorityAndManagementDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',

  'confirmDialog',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpUtilityService',
  'orgDataService',
  'bcpDataService',
  'editInternalContactDialog',
  'editInternalContactDialog',
];
